var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Message',{attrs:{"content":_vm.event.survey.feedback,"user":_vm.event.customer || {},"timestamp":_vm.event.created,"label":"Feedback"}})
}
var staticRenderFns = []

export { render, staticRenderFns }